import BreadCrumb from "../../components/BreadCrumb"
import greenTick from "../../assest/images/green-tick.png";
import giftImg from "../../assest/images/giftImg.png";
import moment from "moment";
import helper, { generateCancellationPolicyCheckout } from "../../common/Helper";
import Booking from "./Booking";
import Payment from "./Payment";
import noTour from "../../assest/myImages/no-tour-img.png";


const Index = ({
    cartDetail,
    productDetail,
    mainContactField,
    passengers,
    passengerField,
    handleChangePassenger,
    handleChangeMainContact,
    handleCountrySelectChange,
    onChangeCustomDropdown,
    onChangeDate,
    handleLanguageSelectChange,
    handleNumberChange,
    handleValidityChange,
    onClickContinue,
    user,
    state,
    changeValue,
    breadcrumbList,
    totalGuest,
    getClassNames,
    showPassword,
    handhandleShowPassword,
    step,
    activeTab,
    onClickPaymentTab,
    setStep,
    cardState,
    onChangeCard,
    stripeSuccess,
    isLoading,
    sendMbwayPaymentRequest,
    mbResponse,
    isMBLoading,
    generateMultiBancoRefrence,
    today,
    isLoginForm,
    setIsLoginForm,
    cartItem,
    isAdmin
}) => {
    let product = productDetail
    let userCartData = cartDetail?.people
    let priceList = productDetail?.product_rate_pricing_categories
    let tieredPriceList = productDetail?.product_rate_tiered_pricing_categories
    let selectedRate = cartDetail?.selectedRate
    const coverImg = helper.S3Url + '/' + helper.productImageDir + '/' + product?.cover_image
    let cancellationPolicy = cartDetail?.selectedRate?.cancellationPolicy
    let selectedDate = cartDetail?.selectedDate
    let startTime = cartDetail?.selectdTime?.startTime
    let isGroup = userCartData?.filter((ct) => ct?.cat == 'GROUP')?.length > 0
    let date = cartDetail?.selectedDate



    return (
        <section className="checkout-one">
            <div className="container">
                <div className="checkout-one-box">
                    <BreadCrumb list={breadcrumbList} />
                    <div className="confirm_and_pay">
                        <div className="confirm_left backLayerCom">
                            <div className="titlebox">
                                <h4 className={`${isLoading ? "skeleton" : ""}`}>Booking details</h4>
                                <span className={`${isLoading ? "skeleton green" : "green"}`} >Booking will take just 15 minutes or even less!</span>
                            </div>
                            <div className={`${isLoading ? "skeleton bookingStep" : "bookingStep"}`}>
                                <ul>
                                    <li onClick={() => setStep(1)} style={{ cursor: "pointer" }}>
                                        <div className={`steps ${step == 1 ? "active" : 'complete'}`}><span>1</span><img src={greenTick} alt="green-tick" /></div>
                                        <h6 className="active">Booking</h6>
                                    </li>
                                    <li><i className="fa-solid fa-chevron-right"></i></li>
                                    <li>
                                        <div className={`steps ${step == 1 ? "" : 'active'}`}><span>2</span><img src={greenTick} alt="green-tick" /></div>
                                        <h6 className="active">Payment</h6>
                                    </li>
                                    <li><i className="fa-solid fa-chevron-right"></i></li>
                                    <li>
                                        <div className="steps"><span>3</span></div>
                                        <h6>Finish</h6>
                                    </li>
                                </ul>
                            </div>
                            <div className="updateDate">
                                <div className={`${isLoading ? "skeleton dateBoxUpdate" : "dateBoxUpdate"}`}>
                                    <div className="datetext">
                                        <span>Date</span>
                                        <h6>{moment(cartDetail?.selectedDate).format('MMMM D, YYYY')}</h6>
                                    </div>
                                </div>
                                <div className={`${isLoading ? "skeleton dateBoxUpdate" : "dateBoxUpdate"}`}>
                                    <div className="datetext">
                                        <span>Guest</span>
                                        <h6 className='notranslate' translate="no" >{totalGuest} {isGroup ? 'Group' : 'guest'}</h6>
                                    </div>
                                </div>
                            </div>
                            {
                                step == 1 &&
                                <Booking
                                    key={`booking`}
                                    user={user}
                                    state={state}
                                    changeValue={changeValue}
                                    showPassword={showPassword}
                                    getClassNames={getClassNames}
                                    handhandleShowPassword={handhandleShowPassword}
                                    mainContactField={mainContactField}
                                    passengerField={passengerField}
                                    passengers={passengers}
                                    handleCountrySelectChange={handleCountrySelectChange}
                                    handleChangeMainContact={handleChangeMainContact}
                                    onChangeCustomDropdown={onChangeCustomDropdown}
                                    onChangeDate={onChangeDate}
                                    handleLanguageSelectChange={handleLanguageSelectChange}
                                    handleNumberChange={handleNumberChange}
                                    handleValidityChange={handleValidityChange}
                                    handleChangePassenger={handleChangePassenger}
                                    isLoading={isLoading}
                                    isLoginForm={isLoginForm}
                                    setIsLoginForm={setIsLoginForm}

                                />
                            }
                            {
                                step == 2 &&
                                <Payment
                                    key={`payment`}
                                    activeTab={activeTab}
                                    onClickPaymentTab={onClickPaymentTab}
                                    cardState={cardState}
                                    onChangeCard={onChangeCard}
                                    stripeSuccess={stripeSuccess}
                                    onClickContinue={onClickContinue}
                                    sendMbwayPaymentRequest={sendMbwayPaymentRequest}
                                    mbResponse={mbResponse}
                                    isMBLoading={isMBLoading}
                                    generateMultiBancoRefrence={generateMultiBancoRefrence}
                                    cartItem={cartItem}
                                    isAdmin={isAdmin}

                                />
                            }


                            {
                                step == 1 &&

                                < div className={`${isLoading ? "skeleton continueBox" : "continueBox"}`}>
                                    {/* <button className="btn btnGift"><img src={giftImg} alt="giftImg" />Enter promo code</button> */}
                                    <button className="btn continueBtn" onClick={() => onClickContinue()}>Continue <i className="fa-solid fa-circle-arrow-right"></i></button>
                                </div>
                            }
                        </div>
                        <div className="desktopCard">
                            <div className="confirm_right backLayerCom">
                                <div className="orderSummery">
                                    <h4 className={`${isLoading ? "skeleton" : ""}`}>Order summary</h4>
                                    <div className={`${isLoading ? "skeleton placeName" : "placeName"}`}>
                                        <div className="img">
                                            <img src={coverImg}
                                                alt="wave-img"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = noTour
                                                }}
                                            />
                                        </div>
                                        <div className="polaceText">
                                            <h5>{product?.title}</h5>
                                            <p><i className="fa-solid fa-location-dot"></i> {product?.address ? product?.address : '-'}</p>
                                        </div>
                                    </div>
                                    <div className="canceldate">
                                        <p className={`${isLoading ? "skeleton " : ""}`}>Free cancellation <span>{cancellationPolicy && generateCancellationPolicyCheckout(JSON.stringify(cancellationPolicy), selectedDate, startTime, product?.product_detail?.time_zone)}</span></p>
                                        {/* <p>Great value <span>Rated 4.6/5 for value.</span></p> */}
                                    </div>
                                    <div className={`${isLoading ? "skeleton finalBox" : "finalBox"}`}>
                                        <ul>
                                            <li >
                                                {
                                                    userCartData?.map((uc, i) => {
                                                        const tier = selectedRate.tiers.find(t =>
                                                            t?.pricingCategoryId === uc.catId &&
                                                            t?.activityRateId === selectedRate.id &&
                                                            t?.maxPassengersRequired != null
                                                        );
                                                        let pricingAry = priceList && (priceList).length ? (priceList) : [];
                                                        let tieredPricingAry = tieredPriceList && (tieredPriceList).length ? (tieredPriceList) : [];


                                                        // var catAmt = pricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId).length > 0 ? pricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId)[0].amount : 0
                                                        // if (tier) {
                                                        //     catAmt = tieredPricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId).length > 0 ? tieredPricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId)[0].amount : 0
                                                        // }

                                                        var catAmt = 0
                                                        if (selectedRate.tieredPricingEnabled && tier) {
                                                            if (tier) {
                                                                // var match = tieredPricingAry.find(
                                                                //     (p) =>
                                                                //         p.rateId == selectedRate.id &&
                                                                //         p.pricingCategoryId == uc.catId &&
                                                                //         date >= p.from &&
                                                                //         date <= (p.to ? p.to : today) &&
                                                                //         // (p.minQty <= Number(uc.qty) && p.maxQty >= Number(uc.qty))
                                                                //         // (uc.qty >= Number(p.minQty) && uc.qty >= Number(p.maxQty))
                                                                //         (
                                                                //             p.maxQty != null ?
                                                                //                 uc.qty >= Number(p.minQty) && uc.qty >= Number(p.maxQty) : true)
                                                                // );
                                                                let match = tieredPricingAry.find((p) => {
                                                                    const minKey = 'minQty' in p ? 'minQty' : 'minPassengersRequired';
                                                                    const maxKey = 'maxQty' in p ? 'maxQty' : 'maxPassengersRequired';

                                                                    return (
                                                                        p.rateId == selectedRate.id &&
                                                                        p.pricingCategoryId == uc.catId &&
                                                                        date >= p.from &&
                                                                        date <= (p.to ? p.to : today) &&
                                                                        uc.qty >= Number(p[minKey]) &&
                                                                        uc.qty <= Number(p[maxKey])
                                                                    );
                                                                });
                                                                catAmt = match ? match.amount : 0;
                                                            }
                                                        } else {

                                                            var match = pricingAry.find(
                                                                (p) =>
                                                                    p.rateId == selectedRate.id &&
                                                                    p.pricingCategoryId == uc.catId &&
                                                                    date >= p.from &&
                                                                    date <= (p.to ? p.to : today) &&
                                                                    (selectedRate.maxPerBooking != null ?
                                                                        uc.qty >= Number(selectedRate.minPerBooking) && uc.qty <= Number(selectedRate.maxPerBooking) : true
                                                                    )
                                                            );
                                                            catAmt = match ? match.amount : 0;

                                                        }






                                                        return (
                                                            selectedRate.pricedPerPerson ?
                                                                <p key={i}>{uc?.title} {uc.qty} x €{catAmt}<span className='notranslate' translate="no">€{Number(uc.qty) * Number(catAmt)}</span></p> :
                                                                <p key={i}>{uc?.title} {uc.qty}<span>€{Number(catAmt)}</span></p>
                                                        )
                                                    })
                                                }
                                            </li>
                                        </ul>
                                        <div className="totalBox">
                                            <div className="rateBox">
                                                <h5>Total <span>(EUR)</span></h5>
                                            </div>
                                            <div className="ourprice">
                                                <h6 className='notranslate' translate="no">€{Number(selectedRate?.totalPrice).toFixed(2)}</h6>
                                                <p>All taxes and fees included</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mobileCard">
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            Order summary
                                            <div className="totalBox">
                                                <div className="rateBox">
                                                    <h5>Total <span>(EUR)</span></h5>
                                                </div>
                                                <div className="ourprice">
                                                    <h6 className='notranslate' translate="no">€{Number(selectedRate?.totalPrice).toFixed(2)}</h6>
                                                    <p>All taxes and fees included</p>
                                                </div>
                                            </div>
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div className="accordion-body confirm_right">
                                            <div className="orderSummery">
                                                <div className="placeName">
                                                    <div className="img">
                                                        <img src={coverImg}
                                                            alt="wave-img"
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = noTour
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="polaceText">
                                                        <h5>{product?.title}</h5>
                                                        <p><i className="fa-solid fa-location-dot"></i> {product?.address ? product?.address : '-'}</p>
                                                    </div>
                                                </div>
                                                <div className="canceldate">
                                                    <p>Free cancellation <span>{cancellationPolicy && generateCancellationPolicyCheckout(JSON.stringify(cancellationPolicy), selectedDate, startTime, product?.product_detail?.time_zone)}</span></p>
                                                    {/* <p>Great value <span>Rated 4.6/5 for value.</span></p> */}
                                                </div>
                                                <div className="finalBox">
                                                    <ul>
                                                        <li>
                                                            {
                                                                userCartData?.map((uc, i) => {
                                                                    const tier = selectedRate.tiers.find(t =>
                                                                        t?.pricingCategoryId === uc.catId &&
                                                                        t?.activityRateId === selectedRate.id &&
                                                                        t?.maxPassengersRequired != null
                                                                    );
                                                                    let pricingAry = priceList && (priceList).length ? (priceList) : [];
                                                                    let tieredPricingAry = tieredPriceList && (tieredPriceList).length ? (tieredPriceList) : [];


                                                                    // var catAmt = pricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId).length > 0 ? pricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId)[0].amount : 0
                                                                    // if (tier) {
                                                                    //     catAmt = tieredPricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId).length > 0 ? tieredPricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId)[0].amount : 0
                                                                    // }

                                                                    var catAmt = 0
                                                                    if (selectedRate.tieredPricingEnabled && tier) {

                                                                        // var match = tieredPricingAry.find(
                                                                        //     (p) =>
                                                                        //         p.rateId == selectedRate.id &&
                                                                        //         p.pricingCategoryId == uc.catId &&
                                                                        //         date >= p.from &&
                                                                        //         date <= (p.to ? p.to : today) &&
                                                                        //         // (p.minQty <= Number(uc.qty) && p.maxQty >= Number(uc.qty))
                                                                        //         // (uc.qty >= Number(p.minQty) && uc.qty >= Number(p.maxQty))
                                                                        //         (
                                                                        //             p.maxQty != null ?
                                                                        //                 uc.qty >= Number(p.minQty) && uc.qty >= Number(p.maxQty) : true)
                                                                        // );
                                                                        let match = tieredPricingAry.find((p) => {
                                                                            const minKey = 'minQty' in p ? 'minQty' : 'minPassengersRequired';
                                                                            const maxKey = 'maxQty' in p ? 'maxQty' : 'maxPassengersRequired';

                                                                            return (
                                                                                p.rateId == selectedRate.id &&
                                                                                p.pricingCategoryId == uc.catId &&
                                                                                date >= p.from &&
                                                                                date <= (p.to ? p.to : today) &&
                                                                                uc.qty >= Number(p[minKey]) &&
                                                                                uc.qty <= Number(p[maxKey])
                                                                            );
                                                                        });
                                                                        catAmt = match ? match.amount : 0;

                                                                    } else {

                                                                        var match = pricingAry.find(
                                                                            (p) =>
                                                                                p.rateId == selectedRate.id &&
                                                                                p.pricingCategoryId == uc.catId &&
                                                                                date >= p.from &&
                                                                                date <= (p.to ? p.to : today) &&
                                                                                // (uc.qty >= Number(selectedRate.minPerBooking) && uc.qty >= Number(selectedRate.maxPerBooking))

                                                                                (selectedRate.maxPerBooking != null ?
                                                                                    uc.qty >= Number(selectedRate.minPerBooking) && uc.qty <= Number(selectedRate.maxPerBooking) : true
                                                                                )


                                                                        );
                                                                        catAmt = match ? match.amount : 0;

                                                                    }



                                                                    return (
                                                                        selectedRate.pricedPerPerson ?
                                                                            <p key={i}>{uc?.title} {uc.qty} x €{catAmt}<span>€{Number(uc.qty) * Number(catAmt)}</span></p> :
                                                                            <p key={i}>{uc?.title} {uc.qty}<span>€{Number(catAmt)}</span></p>
                                                                    )
                                                                })
                                                            }
                                                        </li>
                                                    </ul>
                                                    <div className="totalBox">
                                                        <div className="rateBox">
                                                            <h5>Total <span>(EUR)</span></h5>
                                                        </div>
                                                        <div className="ourprice">
                                                            <h6>€{Number(selectedRate?.totalPrice).toFixed(2)}</h6>
                                                            <p>All taxes and fees included</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )

}
export default Index